// 使用以下hooks 来代替直接使用 `useDispatch` 和 `useSelector`，方便获得类型支持

import {TypedUseSelectorHook, useDispatch, useSelector} from 'react-redux'

import {AppDispatch, RootState} from './configureStore'
import {store} from './getStore'

// export const useAppDispatch: () => AppDispatch = useDispatch
export const useAppDispatch = (): AppDispatch => useDispatch<AppDispatch>()
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector
